import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import {
	AutocompleteArrayInput,
	AutocompleteInput,
	Filter,
	ReferenceInput,
	SelectInput,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import { usersConfig } from "../users";
import statuses from "./statuses";

const Filters = (props) => {
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<Filter {...props} variant="outlined">
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				alwaysOn
				fullWidth
				style={{ marginTop: theme.spacing(4) }}
				{...bookmakersConfig.reference}
			>
				<AutocompleteArrayInput optionText="name" />
			</ReferenceInput>
			<ReferenceInput
				source="user_id"
				reference="users"
				alwaysOn={!sm}
				fullWidth
				{...usersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<SelectInput
				source="status"
				choices={statuses}
				optionText="name"
				alwaysOn
				resettable
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
			/>
		</Filter>
	);
};
export default Filters;
